import { render } from "./editor.vue?vue&type=template&id=0f198ada"
import script from "./editor.vue?vue&type=script&lang=js"
export * from "./editor.vue?vue&type=script&lang=js"
script.render = render

export default script